import { useState, useEffect } from "react";
import { api } from "./utils/apiInstance";
import { Fade } from "react-awesome-reveal";
import Footer from "./Footer";
import Header from "./Header";

const Opinions = () => {
    const [opinions, setOpinions] = useState([]);

    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [opinion, setOpinion] = useState("");

    // ---- Fetch function extracted ----
    const fetchOpinions = () => {
        fetch(`${api}/api/opinions`)
            .then((res) => res.json())
            .then((data) => setOpinions(data))
            .catch((err) => console.log("Fetch error:", err));
    };

    // FETCH ALL OPINIONS ON LOAD
    useEffect(() => {
        fetchOpinions();
    }, []);

    // HANDLE FORM SUBMISSION
    const handleSubmit = async (e) => {
        e.preventDefault();

        await fetch(`${api}/api/opinions`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                userName,
                email,
                opinion,
            }),
        });

        // Clear form
        setUserName("");
        setEmail("");
        setOpinion("");

        // ---- Fetch updated opinions with real createdAt ----
        fetchOpinions();
    };

    // Format date
    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("pl-PL", {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);

    useEffect(() => {
        setShow1(true); // pierwsze zdanie od razu po załadowaniu

        const timer2 = setTimeout(() => {
            setShow2(true);
        }, 3000);

        const timer3 = setTimeout(() => {
            setShow3(true);
        }, 5000);

        return () => {
            clearTimeout(timer2);
            clearTimeout(timer3);
        };
    }, []);
    return (
        <div className="opinions">
            <Fade className="fade_header" duration={2000}>
                <Header />
            </Fade>

            <div className="opinions-container">
                <div className="opinions-intro">
                    <div className="opinion-header-box">
                        <h2>Opinie klientów</h2>
                        <img
                            className="opinion-img"
                            src="https://res.cloudinary.com/dx9rdmmff/image/upload/v1764519229/Magda/dl9avj7q9baq5scqci7eim3ife_n7xlzb.png"
                            alt="opinions"
                        />
                    </div>
                    <span className="line"></span>

                    <div className="delay-p">
                        {show1 && (
                            <p
                                className="fadeText"
                                style={{ fontWeight: "bold" }}
                            >
                                Wasze opinie pomagają mi się rozwijać oraz
                                dostarczać usługi na najwyższym poziomie.
                            </p>
                        )}
                        {show2 && (
                            <p className="fadeText">
                                Dziękuję za każde zostawione słowo❤️
                            </p>
                        )}
                        {show3 && (
                            <p className="fadeText">
                                Gorąco zachęcam do dodania własnej recenzji ⭐️
                            </p>
                        )}
                    </div>
                </div>
                <div className="opinions-list">
                    {opinions.map((item, index) => (
                        <div className="opinion-item" key={item._id || index}>
                            <p>
                                <strong>{item.userName}</strong>: {item.opinion}
                            </p>
                            <p>{formatDate(item.createdAt)}</p>
                        </div>
                    ))}
                </div>

                <div className="opinions-form-box">
                    <h2>Dodaj opinię</h2>

                    <form className="opinions-form" onSubmit={handleSubmit}>
                        <input
                            className="opinions-input"
                            placeholder="Imię"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                        />
                        <input
                            className="opinions-input"
                            placeholder="e-mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <textarea
                            className="opinions-textarea"
                            placeholder="Twoja opinia"
                            value={opinion}
                            onChange={(e) => setOpinion(e.target.value)}
                        />
                        <button className="opinions-button" type="submit">
                            Wyślij
                        </button>
                    </form>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Opinions;
